var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"media-icons"},_vm._l((_setup.BINARY_MEDIA_LIST),function(icon){return _c('el-image',{directives:[{name:"show",rawName:"v-show",value:(_vm.value.includes(icon.value)),expression:"value.includes(icon.value)"}],key:icon.value,attrs:{"src":`/images/lib/${icon.imagePrefix}.png`,"fit":"fit"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }